import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({encodingType: 'rc4', isCompression: false});
ls.removeAll();
import UserService from '../services/user.service';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    something:true,
   
    pricedm:[],
    price:[],
    
    showHeader:false
  },
  plugins: [
  
  createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
  mutations: {
    SET_SOMETHING(state, something){
      state.something = something;
    },
    SET_PRICE(state, price){
      state.price = price;
    },
    SET_PRICE_DM(state, pricedm){
      state.pricedm = pricedm;
    },
    
    SET_SHOW_HEADER(state, showHeader){
      state.showHeader = showHeader;
    }
  },

  actions: {

    async initialize({commit}){
      commit("SET_SOMETHING", false);
    },

    async showheader({commit}){
      commit("SET_SHOW_HEADER", true);
    },

    async getprice({ commit}){
      commit("SET_SOMETHING", true);
      const price = await UserService.getprice()
                    .then(response => {
                    if (response.data!=='' && response.data.constructor === Object){
                      var reStatus = response.data.response.status;
                        if(reStatus == '300' || reStatus == '301' || reStatus == '302' || reStatus == '114'){
                          return [];
                        } else {
                          return response.data.response.result;
                        }
                    } else {
                      return [];
                    }
                    });

      //sidor prices
      const arrayprices = [225,228,229,733];
      const sidorprices = await price.filter(obj => arrayprices.includes(obj.id));
      if (sidorprices.length > 0){
        commit("SET_PRICE", sidorprices);
      }
      //sidordm prices
      const arraypricesdm = [2225,2228,2229,2233];
     
      const sidorDMprices = await price.filter(obj => arraypricesdm.includes(obj.id));
      if (sidorDMprices.length > 0){
        commit("SET_PRICE_DM", sidorDMprices);
      }
    },

    async ordernow({commit},{product, referrer}){
          commit("SET_SOMETHING", true);
          const appUrl = await UserService.ordernow(product, referrer)
                    .then(response => {
                    if (response.data!=='' && response.data.constructor === Object){
                        var reStatus = response.data.response.status;
                        if(reStatus == '300' || reStatus == '301' || reStatus == '302'){
                          return '';
                        } 
                        else if (reStatus == '111') {
                          return '';
                        }
                        else {
                          return response.data.response.result;
                        }
                    } else {
                      return '';
                    }
                    });
          
          window.location.replace(appUrl);               
    },
   
  },
  
  getters: {
    getPrice(state){
      return state.price;
    },
    getPriceDm(state){
      return state.pricedm;
    },
    getShowHeader(state){
      return state.showHeader;
    }
  }
  
});